import { styled } from '@mui/material';

/**
 * The input's action rows fade in as they swap (voice button, recording controls, filled actions). Layout comes from
 * Tailwind classes on the element; only the animation lives here.
 */
export const FadeIn = styled('div')({
  '@keyframes formsInputFade': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  animation: 'formsInputFade 160ms var(--ease-entrance) both',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
});
